Tpl =
  ###*
   * error modal
  ###
  errorModal: """
    <div id="errorModal" class="modal modal-error">
      <div class="modal_dialog">
        <div class="modal_content">
          <div class="modal_content_head">ERROR!</div>
          <div class="modal_content_body"><p></p></div>
          <div class="modal_content_foot">
            <a id="errorModalClose" href="javascript:void(0)" class="btn">CLOSE</a>
          </div>
        </div>
      </div>
    </div>
  """


  ###*
   * dialog modal
  ###
  dialogModal: """
    <div class="modal" id="dialogModal">
      <div class="modal_dialog">
        <div class="modal_content">
          <div class="modal_content_head"></div>
          <div class="modal_content_body"><p></p></div>
          <div class="modal_content_foot">
            <a href="javascript:void(0)" class="btn btn-cancel">CANCEL</a>
            <a href="javascript:void(0)" class="btn btn-submit">OK</a>
            <a href="javascript:void(0)" class="btn btn-close">CLOSE</a>
          </div>
        </div>
      </div>
    </div>
  """

module.exports = Tpl


// WEBPACK FOOTER //
// ./src/scripts/modules/Tpl.coffee